import {Component, OnInit} from '@angular/core';
import {EventService} from '../../shared';
// mport { CognitoAuthService } from '../../shared/auth/cognito.service';
// declare const moment: any;

@Component({
    selector: 'events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {

    /*
     isEventsDataLoading = true;
     isEventsDataError = false;
     maxEventDataCallRetries = 3;
     eventsDataSubscription;

     events = [];

     risks = ['LOW', 'MEDIUM', 'HIGH'];
     riskClasses = ['bg-risk-low', 'bg-risk-medium', 'bg-risk-high'];
     icons = ['bomb', 'bug', 'sliders', 'crosshairs', 'info-circle'];
     */


    // constructor(private eventService: EventService, private authService: CognitoAuthService) {
    constructor() {
    }

    ngOnInit() {

        // this.getEvents();

    }


    getEvents() {
        /*
         const self = this;

         this.authService.getIdToken({
         callback() {},
         callbackWithParam(idToken:any) {
         var customer = self.authService.decodeToken(idToken)["custom:customer"];
         self.eventsDataSubscription = self.eventService.getEvents(idToken, [], customer).subscribe(function (events) {
         // console.log('events = ');
         // console.dir(events);

         // Adjust the Date field a bit in the Events list
         events.forEach(function (event) {
         event.event_ts = event.event_ts.substring(0, 19).replace('T', ' ');
         });
         self.events = events;
         self.isEventsDataLoading = false;
         self.isEventsDataError = false;
         }, function (err) {

         console.log('Error in getEvents() of dashboard.component');

         self.events = [];
         self.isEventsDataLoading = false;
         self.isEventsDataError = true;

         self.eventsDataSubscription.unsubscribe();
         --self.maxEventDataCallRetries;
         if (self.maxEventDataCallRetries > 0) {
         self.getEvents();
         }
         });
         }
         });
         */
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/events/events.component.ts